import Text from "@/blueprint/components/Text/Text";
import {
  LANDING_PACKAGE_CART_COPY,
  getLandingPackageCodeConflict,
} from "@/cart/landingPackage";
import type { Cart } from "@/graphql/storefront/generated";

/**
 * A landing-page package and a code don't stack (pre-BF bundle rules). Rather
 * than let the code fail silently at checkout, the cart says so up front.
 */
const LandingPackageCodeNotice = ({ cart }: { cart: Cart | undefined }) => {
  const packageId = getLandingPackageCodeConflict(cart);
  if (packageId === null) return null;

  return (
    <div role="status" className="px-8 pt-4 md:px-12">
      <Text variant="paragraph-sm" tone="secondary" as="p">
        {LANDING_PACKAGE_CART_COPY.codeConflict(
          LANDING_PACKAGE_CART_COPY.packageNames[packageId],
        )}
      </Text>
    </div>
  );
};

export default LandingPackageCodeNotice;
